import React, { useState, useEffect } from 'react';
import './ProductIngredients.css';

const ProductIngredients = () => {
    const [activeSlide, setActiveSlide] = useState(0);

    const ingredients = [
        {
            name: "Citric Acid",
            scientificName: "C₆H₈O₇",
            description: "Natural acid with powerful cleaning efficacy",
            benefit: "Used to give thick product consistency",
            icon: "🧪",
            color: "#2196F3",
            gradient: "linear-gradient(135deg, #2196F3, #1976D2)"
        },
        {
            name: "Acetic Acid",
            scientificName: "CH₃COOH",
            description: "Powerful cleansing action",
            benefit: "Plant-derived disinfectant",
            icon: "🌿",
            color: "#4CAF50",
            gradient: "linear-gradient(135deg, #4CAF50, #2E7D32)"
        },
        {
            name: "Plant Enzymes",
            scientificName: "Bio-Catalytic",
            description: "Molecular stain removal",
            benefit: "Targeted cleaning proteins",
            icon: "🔬",
            color: "#9C27B0",
            gradient: "linear-gradient(135deg, #9C27B0, #7B1FA2)"
        }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveSlide((prev) => (prev + 1) % ingredients.length);
        }, 4000);

        return () => clearInterval(interval);
    }, [ingredients.length]);

    return (
        <div className="science-banner">
            <div className="banner-background">
                <div className="floating-dna"></div>
                <div className="floating-molecule"></div>
                <div className="pulse-ring"></div>
            </div>

            <div className="banner-content">
                <div className="banner-header">
                    <div className="tagline-section">
                        <h1 className="main-headline">
                            <span className="science-text">SCIENCE</span>
                            <span className="meets-text">MEETS</span>
                            <span className="nature-text">NATURE</span>
                        </h1>
                        <div className="efficacy-badge">
                            <div className="efficacy-numbers">
                                <span className="positive">100%</span>
                                <span className="negative">0%</span>
                            </div>
                            <div className="efficacy-labels">
                                <span style={{ display: "block", marginBottom: "20px" }}>
                                    CLEANING POWER
                                </span>

                                <span>TOXIC CHEMICALS</span>
                            </div>
                        </div>
                    </div>

                    <div className="ingredient-display">
                        <div className="ingredient-slider">
                            {ingredients.map((ingredient, index) => (
                                <div
                                    key={index}
                                    className={`ingredient-slide ${activeSlide === index ? 'active' : ''}`}
                                    style={{ background: ingredient.gradient }}
                                >
                                    <div className="slide-content">
                                        <div className="ingredient-icon">{ingredient.icon}</div>
                                        <div className="ingredient-details">
                                            <h3>{ingredient.name}</h3>
                                            <div className="scientific-name">{ingredient.scientificName}</div>
                                            <p className="description">{ingredient.description}</p>
                                            <p className="benefit">{ingredient.benefit}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="slide-indicators">
                            {ingredients.map((_, index) => (
                                <button
                                    key={index}
                                    className={`indicator ${activeSlide === index ? 'active' : ''}`}
                                    onClick={() => setActiveSlide(index)}
                                />
                            ))}
                        </div>
                    </div>
                </div>

                <div className="banner-footer">
                    <div className="science-features">
                        <div className="feature">
                            <i className="fa-solid fa-flask feature-icon"></i>
                            <span>Lab Tested</span>
                        </div>
                        <div className="feature">
                            <i className="fa-solid fa-leaf feature-icon"></i>
                            <span>Plant Derived</span>
                        </div>
                        <div className="feature">
                            <i className="fa-solid fa-magnifying-glass feature-icon"></i>
                            <span>Molecular Action</span>
                        </div>
                    </div>


                    <button className="cta-btn primary">
                        <span className="btn-glow"></span>
                        <span className="btn-text">
                            Contact Us
                            <svg className="btn-icon" viewBox="0 0 24 24">
                                <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
                            </svg>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProductIngredients;